module.exports = __webpack_public_path__ + "img/charging-station-regular.216736c4.svg";